import { z } from "zod";

// Coerce single values to arrays for params that accept arrays
export const asArray = z.preprocess(
  (val) => (val == null ? undefined : Array.isArray(val) ? val : [val]),
  z.array(z.string()).default([])
);

// Coerce "true"/true search-param values to a boolean that defaults to false
export const asBoolean = z.preprocess(
  (val) => val === "true" || val === true,
  z.boolean().default(false)
);

/**
 * Shared search param schema for any route that embeds BaseDataAssetList.
 * Used by: /data/assets/search, /data/sets/$publicId, and any other route
 * that renders the data asset list with filters.
 */
export const dataAssetSearchSchema = z.object({
  query: z.string().default(""),
  sealogEventQuery: z.string().default(""),
  exclude: z.string().default(""),
  dataSetPublicIds: asArray,
  manifestPublicIds: asArray,
  realAssetPublicIds: asArray,
  realAssetDeploymentPublicIds: asArray,
  sealogEventValues: asArray,
  sealogEventFreeTexts: asArray,
  sealogEventOptionNames: asArray,
  sealogEventOptionValues: asArray,
  fileTypes: asArray,
  assetModifiedBefore: z.string().nullable().default(null),
  assetModifiedAfter: z.string().nullable().default(null),
  page: z.number().default(1),
  regex: asBoolean,
  verifiedOnly: asBoolean,
  cloudOnly: z.preprocess((val) => val !== "false" && val !== false, z.boolean().default(true)),
  size: z.preprocess((val) => (val != null ? Number(val) : undefined), z.number().default(10)),
  sortField: z.string().default("asset_updated_dt"),
  sortOrder: z.string().default("desc"),
});

/**
 * The schema's default values — single source of truth.
 * Used by hooks for "has non-default params" checks, "clear all" resets,
 * and URL stripping. Derived from the schema so they can never drift.
 */
export const dataAssetSearchDefaults = dataAssetSearchSchema.parse({});
